import React from "react";
import { Link } from "react-router-dom";
import { Tag } from "..";
import { usePostTags } from "../../hooks";

export default function WikiTagFilter({
  tags,
  filteredTags,
  setFilteredTags,
  showButton = false,
}) {
  const { addNewTag, getNewTagFromUser, refreshTags } = usePostTags({
    initialize: false,
  });

  const isButtonShown = showButton && (!tags || tags.length === 0);
  return (
    <div>
      {isButtonShown ? (
        <button
          onClick={async () => {
            const nextTag = await getNewTagFromUser({ value: "NEW" });
            if (nextTag) {
              await addNewTag({ tagName: nextTag });
              refreshTags();
            }
          }}
        >
          Add a HUBtag
        </button>
      ) : (
        <>
          <p>Filter by tag:</p>
          <p class="filter-tag-container">
            {tags.map((tag) => (
              <Tag
                key={tag.name}
                tagName={tag.name}
                isFiltered={filteredTags.includes(tag._id)}
                onClick={() => {
                  if (filteredTags.includes(tag._id)) {
                    setFilteredTags(
                      filteredTags.filter(
                        (filteredTag) => filteredTag !== tag._id
                      )
                    );
                  } else {
                    setFilteredTags([...filteredTags, tag._id]);
                  }
                }}
                showDelete={false}
                deleteTag={() => null}
              />
            ))}
          </p>
        </>
      )}

      {tags && tags.length > 0 && <Link to="/tags">Manage HUBtags</Link>}
      <hr />
    </div>
  );
}
